/**
 * Compact in-match note panel. Steals the keyboard until Submit / Later / Esc.
 */
const NOTE_MAX = 280;

const FeedbackComposer = {
  _el: null,
  _onLater: null,
  _onEsc: null,

  isOpen() {
    return Boolean(this._el);
  },

  open({ id, onSubmit, onLater } = {}) {
    if (this.isOpen()) return;
    this._onLater = typeof onLater === 'function' ? onLater : () => {};

    const panel = document.createElement('div');
    panel.id = 'feedbackComposer';
    panel.style.cssText = `
      position: fixed;
      left: 50%;
      top: 28%;
      transform: translateX(-50%);
      width: min(420px, 90vw);
      background: rgba(20, 20, 24, 0.95);
      border: 1px solid #666;
      border-radius: 8px;
      padding: 16px;
      z-index: 1500;
      color: white;
      font-family: Arial, sans-serif;
      box-shadow: 0 8px 24px rgba(0,0,0,0.5);
    `;

    const label = document.createElement('div');
    label.textContent = 'Flag note';
    label.style.cssText = 'font-size: 14px; margin-bottom: 8px; color: #ccc;';
    panel.appendChild(label);

    const input = document.createElement('textarea');
    input.maxLength = NOTE_MAX;
    input.rows = 3;
    input.style.cssText = 'width: 100%; box-sizing: border-box; resize: none; font-size: 14px; padding: 8px;';
    input.addEventListener('keydown', (e) => e.stopPropagation());
    panel.appendChild(input);

    const row = document.createElement('div');
    row.style.cssText = 'display: flex; gap: 8px; justify-content: flex-end; margin-top: 10px;';

    const later = document.createElement('button');
    later.id = 'feedbackComposerLater';
    later.textContent = 'Later';
    later.style.cssText = 'padding: 8px 16px; cursor: pointer;';
    later.onclick = () => {
      const laterCb = this._onLater;
      this.close();
      laterCb(id);
    };

    const submit = document.createElement('button');
    submit.id = 'feedbackComposerSubmit';
    submit.textContent = 'Submit';
    submit.style.cssText = 'padding: 8px 16px; cursor: pointer;';
    submit.onclick = () => {
      const note = input.value.trim();
      this.close();
      if (typeof onSubmit === 'function') onSubmit(id, note);
    };

    row.appendChild(later);
    row.appendChild(submit);
    panel.appendChild(row);
    document.body.appendChild(panel);
    this._el = panel;
    input.focus();

    this._onEsc = (e) => {
      if (e.key !== 'Escape') return;
      e.preventDefault();
      const laterCb = this._onLater;
      this.close();
      laterCb(id);
    };
    document.addEventListener('keydown', this._onEsc);
  },

  close() {
    if (this._onEsc) {
      document.removeEventListener('keydown', this._onEsc);
      this._onEsc = null;
    }
    this._onLater = null;
    if (this._el) {
      this._el.remove();
      this._el = null;
    }
  }
};

export { FeedbackComposer };
